import { useMemo } from 'react';
import useAppStore from '../store/appStore';
import { deriveAvailableTags } from '../utils/tags';

/**
 * Hook that returns a unified, deduplicated list of all tags across every lead.
 * Reads from centralized Zustand store (populated by realtimeSubscriptions).
 *
 * Use this in modules that don't already have a leads subscription
 * (e.g. Capture Tools / Website Builder).
 *
 * @returns {string[]} Sorted unique tags derived from all leads
 */
export const useGlobalTags = () => {
  const leads = useAppStore((s) => s.leads);
  return useMemo(() => deriveAvailableTags(leads || []), [leads]);
};
